import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  myautoiqTemplateGenerationSettings: { data: null, loading: false, error: null },
};

const myautoiqTemplateGenerationSettingsSlice = createSlice({
  name: 'myautoiqTemplateGenerationSettingsComponentState',
  initialState,
  reducers: {
    requestMyautoiqTemplateGenerationSettings(state, action: PayloadAction<any>) {
      state.myautoiqTemplateGenerationSettings.loading = true;
      state.myautoiqTemplateGenerationSettings.error = null;
    },
    requestMyautoiqTemplateGenerationSettingsSuccess(state, action: PayloadAction<any>) {
      state.myautoiqTemplateGenerationSettings.data = action.payload;
      state.myautoiqTemplateGenerationSettings.loading = false;
    },
    requestMyautoiqTemplateGenerationSettingsError(state, action: PayloadAction<any>) {
      state.myautoiqTemplateGenerationSettings.error = action.payload;
      state.myautoiqTemplateGenerationSettings.loading = false;
    },
    requestUpdateMyautoiqTemplateGenerationSettings(state, action: PayloadAction<any>) {
      state.myautoiqTemplateGenerationSettings.loading = true;
      state.myautoiqTemplateGenerationSettings.error = null;
    },
    requestUpdateMyautoiqTemplateGenerationSettingsSuccess(state) {
      state.myautoiqTemplateGenerationSettings.loading = false;
    },
    requestUpdateMyautoiqTemplateGenerationSettingsError(
      state,
      action: PayloadAction<any>,
    ) {
      state.myautoiqTemplateGenerationSettings.error = action.payload;
      state.myautoiqTemplateGenerationSettings.loading = false;
    },
  },
});

export const {
  actions: myautoiqTemplateGenerationSettingsActions,
  reducer,
  name: sliceKey,
} = myautoiqTemplateGenerationSettingsSlice;
